/**
 * Which engine produced (or will produce) an upload's labels — the analysis mode, named.
 * Mirrors NetCoreInterfaces/AnalysisEngine.cs; keep the two in lockstep.
 *
 * These are not new names: they are the label-source strings the pipeline already writes to the
 * positionsSource metadata row, so the pose file's stamp and the persisted row speak one vocabulary.
 * The API surfaces the value on mediaStatus and uploadFrames.
 */
export const AnalysisEngine = {
  /** No pose file — nothing has claimed this upload, so it is a candidate for on-device labelling. */
  None: "none",
  /** On-device MediaPipe: client keypoints are the pose source, GPU services skipped. */
  Client: "client-mediapipe",
  /** The GPU services (pose for pose, object detection for ball/club). */
  Gpu: "pose-media-yolo",
} as const;

export type AnalysisEngineName = (typeof AnalysisEngine)[keyof typeof AnalysisEngine];
